import React, { useState } from "react";
import { ScheduleEntry } from "../../Model/ImagingSchedule";
import SchedulingApi from "../../api/SchedulingApi";
import MtiButton from "../Buttons/MtiButton";
import CommandPanel from "../CommandPanel/CommandPanel";

type Props = {
  scheduleEntry: ScheduleEntry;
  style?: React.CSSProperties;
  backBtn: () => void;
};

function isInt(input: string) {
  input = input.trim();
  const parsed = parseInt(input);
  if (isNaN(parsed)) {
    return false;
  }
  if (parsed.toString() !== input) {
    return false;
  }
  return true;
}

export default function ChangePriority({
  scheduleEntry,
  backBtn,
  style = {},
}: Props) {
  const [priorityString, setPriorityString] = useState(
    scheduleEntry.priority.toString()
  );
  const [canSave, setCanSave] = useState(true);

  const handleOK = () => {
    if (isInt(priorityString)) {
      SchedulingApi.setPriority(scheduleEntry, Number.parseInt(priorityString));
      backBtn();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleOK();
    }
  };

  const onPriorityChanged = (e: string) => {
    if (isInt(e)) {
      const p = Number.parseInt(e);
      setCanSave(p >= 1);
    } else {
      setCanSave(false);
    }
    setPriorityString(e);
  };

  return (
    <CommandPanel
      style={{
        ...style,
      }}
    >
      <CommandPanel.BackArrowHeader
        onBackArrowClick={backBtn}
        title="Set Priority"
      />
      <CommandPanel.VerticalContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              flexGrow: 1,
              fontSize: "20px",
            }}
          >
            Priority
          </div>
          <div style={{ fontSize: "20px" }}>:</div>
          <input
            onChange={(e) => onPriorityChanged(e.target.value)}
            value={priorityString}
            style={{
              flexGrow: 1,
              marginLeft: 13,
              height: 34,
              fontSize: 14,
            }}
            type="text"
            id="barcodeInput"
            onKeyDown={handleKeyDown}
          />
        </div>
        <div
          style={{
            marginTop: 27,
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "stretch",
            height: 66,
          }}
        >
          <MtiButton
            disabled={!canSave}
            onClick={handleOK}
            style={{
              width: 190,
              fontSize: 27,
            }}
          >
            OK
          </MtiButton>
        </div>
      </CommandPanel.VerticalContent>
    </CommandPanel>
  );
}
